import styled from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${stylesGlobalDefault.blue};
    border-radius: 2px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const LoadingContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1500;
  color: black;
`;
